import React, { Component } from "react";
import SearchResult from './result';
import Info from "./info";
import Pagination from "./pagination";
import { SearchResponse, SearchRequest } from "../../rpc/admin/search_pb";
import Adapter from "./adapter";

interface BodyProps {
    adapter: Adapter
    response: SearchResponse
    request: SearchRequest;
    basePath: string;
}

interface BodyState { }

class Body extends Component<BodyProps, BodyState> {

    render() {
        if (!this.props.response?.getHitsList().length) {
            return <></>;
        }
        return (
            <div className="search-body">
                <Info response={this.props.response} request={this.props.request!} adapter={this.props.adapter} />
                <ul>
                    {
                        this.props.response.getHitsList().map((hit) => {
                            return (<SearchResult hit={hit} key={hit.getSku()} basePath={this.props.basePath} />);
                        })
                    }
                </ul>
                <Pagination response={this.props.response} request={this.props.request!} adapter={this.props.adapter} />
            </div>
        );
    }
}

export default Body;